module.exports = __webpack_public_path__ + "img/banner.da663cdc.jpg";